import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CheckIcon from "@mui/icons-material/Check";
import { useScriptMode } from "../../../../contexts/ScriptModeContext";
import { PERIOD_OPTIONS } from "../../../../lib/periodRange";

/** Yalnız simgeli yuvarlak seçici düğmesi (PeriodSelect ve GoalSelect). */
export const ICON_TRIGGER_CLASS =
  "inline-flex items-center justify-center w-9 h-9 rounded-full border border-terakkiBrandMist bg-terakkiSurface text-terakkiPrimaryDark hover:bg-terakkiBrandCloud transition-colors disabled:opacity-50 dark:bg-white/10 dark:border-white/15 dark:text-white dark:hover:bg-white/15";

/**
 * Dönem seçimi: Bugün, Dün, Bu hafta, Geçen hafta, Bu ay, Geçen ay. Düğmeye
 * basınca liste açılır (mobildeki PeriodDropdown ile aynı). variant="icon":
 * içinde yazı olmayan küçük yuvarlak takvim düğmesi; seçim yanda gösterilir.
 */
export default function PeriodSelect({ value, onChange, disabled, variant = "pill" }) {
  const { t } = useScriptMode();
  const [anchor, setAnchor] = useState(null);
  const current = PERIOD_OPTIONS.find((o) => o.key === value) || PERIOD_OPTIONS[0];

  return (
    <>
      {variant === "icon" ? (
        <button
          type="button"
          data-period-trigger="icon"
          disabled={disabled}
          onClick={(e) => setAnchor(e.currentTarget)}
          aria-label={`${t("Dönem seç")}: ${t(current.label)}`}
          title={t("Dönem seç")}
          className={ICON_TRIGGER_CLASS}
        >
          <CalendarMonthOutlinedIcon sx={{ fontSize: 18 }} aria-hidden />
        </button>
      ) : (
        <button
          type="button"
          data-period-trigger
          disabled={disabled}
          onClick={(e) => setAnchor(e.currentTarget)}
          className="inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full border border-terakkiBrandMist bg-terakkiSurface text-terakkiPrimaryDark text-sm font-medium disabled:opacity-50 dark:bg-white/10 dark:border-white/15 dark:text-white"
        >
          <CalendarMonthOutlinedIcon sx={{ fontSize: 16 }} aria-hidden />
          {t(current.label)}
          <KeyboardArrowDownIcon sx={{ fontSize: 18 }} aria-hidden />
        </button>
      )}
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        slotProps={{ paper: { sx: { borderRadius: 3, minWidth: 180 } } }}
      >
        {PERIOD_OPTIONS.map((option) => {
          const selected = option.key === value;
          return (
            <MenuItem
              key={option.key}
              data-period={option.key}
              selected={selected}
              onClick={() => {
                setAnchor(null);
                if (!selected) onChange(option.key);
              }}
              sx={{ justifyContent: "space-between", gap: 2, fontSize: 15 }}
            >
              {t(option.label)}
              {selected ? <CheckIcon fontSize="small" /> : null}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}
